import React from 'react';
import { RiseLoader } from 'react-spinners';

function LoadingScreen() {
  return (
    <div className='loading-screen'><RiseLoader color="#e40718" /> Chargement...</div>
  )
}

export default LoadingScreen